import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "react-bootstrap/lib/Modal";
import Button from "./Button";
import Icon from "./Icon";
import { colors, dimensions } from "../styles";
import { ControlLabel } from "react-bootstrap";

const ModalBody = styled.div`
  text-align: center;
  padding: ${dimensions.coreSpacing}px;
  font-size: 16px;
  font-weight: 500;
`;

const ModalFooter = styled.div`
  padding: 18px ${dimensions.coreSpacing}px;
  border-radius: 0px 0px 20px 20px;
  background: #f4fbfd /* ${colors.colorWhite} */;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
  //border-radius: 0px 0px 20px 20px;
  // border-top: 1px solid ${colors.borderPrimary};
  // border-radius: 4px;
  display: flex;
  justify-content: space-between;
  .blue-btn,
  .grey-btn{
    // font-size: 11px;
    // padding: 12px 19px;
  }
`;

const TextStyle = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  color: black;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0.1em;
`;

const GreyText = styled.div`
  overflow-wrap: break-word;
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #B1B1B1;
  margin-top: 5px;
`;

const IconWrapper = styled.div`
  font-size: 38px;
  color: ${colors.colorSecondary};
`;

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = { show: true };

    this.dismiss = this.dismiss.bind(this);
    this.proceed = this.proceed.bind(this);
  }

  dismiss() {
    this.setState({ show: false }, () => {
      this.props.dismiss();
    });
  }

  proceed(value) {
    this.setState({ show: false }, () => {
      this.props.proceed(value);
    });
  }

  modalImage() {
    const { icon = undefined } = this.props.options;
    console.log('modalimage icon', icon)
    if (icon === "info") {
      return <Icon icon="info-circle" />
    } else if (icon === "sync") {
      return <img src="/images/data-transfer.png" alt="sync button" style={{ maxWidth: '115px', margin: '30px 0' }} />
    } else if (icon === "logout") {
      return (
        <span style={{ fontSize: '90px' }} class="material-symbols-outlined">
          logout
        </span>
      )
    }
    return <img width={this.props.options.width ? this.props.options.width : 90} src={this.props.options.url ? this.props.options.url : "/images/icons/ic_delete_main.svg"} style={{margin: "1rem auto"}} />
  }

  render() {
    const { confirmation = "Are you sure?" } = this.props;

    const {
      okLabel = "Yes, I am",
      cancelLabel = "Cancel",
      enableEscape = true,
      icon = undefined,
      confirmation2 = "You want to delete the selected records? It will be removed from the associated modules.",
      showConfirmation2 = true,
    } = this.props.options;

    return (
      <Modal
        show={this.state.show}
        onHide={this.dismiss}
        backdrop={enableEscape ? true : "static"}
        keyboard={enableEscape}
        bsSize="md"
        dialogClassName="delete-confirmation-modal"
      >
        <button
          onClick={() => this.dismiss()} style={{ backgroundColor: "white", border: "none", padding: "0px", position: "absolute", right: "25px", top: "20px" }} class="material-symbols-outlined">
          cancel
        </button>
        <ModalBody>
          <IconWrapper>
            {/* {icon && icon === "info" && (
              <Icon icon="info-circle" />
            )}
            {!icon && (
              <img src={this.props.options.url ? this.props.options.url : "/images/icons/ic_delete_main.svg"} />
            )} */}
            {this.modalImage()}
          </IconWrapper>
          {/* <ControlLabel
            style={{
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "20px",
              lineHeight: "27px",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#010101",
              // marginTop:'15px'
            }}
          > */}
          <TextStyle>
            {confirmation}
          </TextStyle>
          {showConfirmation2 && (
            <GreyText>
              {confirmation2}
            </GreyText>
          )
          }
          {/* </ControlLabel> */}
          {/* {this.props.options.isDeleted &&
            <p
              style={{
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "22px",
                color: "#B1B1B1",
              }}
            >
              You want to delete the selected records
            </p>
          } */}
        </ModalBody>
        <ModalFooter>
          <Button
            className="grey-btn"
            size="medium"
            btnStyle="simple"
            onClick={this.dismiss}
          //icon="cancel-1"
          >
            {cancelLabel}
          </Button>
          <Button
            className="blue-btn"
            size="medium"
            btnStyle="default"
            onClick={this.proceed}
          //icon="checked-1"
          >
            {okLabel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ConfirmDialog.propTypes = {
  options: PropTypes.object,
  confirmation: PropTypes.string,
  proceed: PropTypes.func,
  dismiss: PropTypes.func,
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ConfirmDialog.js